(function () {
  if (window.__euWarehouseInit) return;
  window.__euWarehouseInit = true;

  var ATTR = 'eu_warehouse_required';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'a[href$="/checkout"]',
    'form[action$="/checkout"] [type="submit"]'
  ];
  var running = null;
  var rerun = false;

  function variantMap() {
    var map = {};
    document.querySelectorAll('script[data-eu-warehouse-variants]').forEach(function (el) {
      try { Object.assign(map, JSON.parse(el.textContent)); } catch (e) {}
    });
    return map;
  }

  function injectProps(body) {
    var map = variantMap();
    function tag(id, props) {
      var v = map[String(id)];
      if (!v) return props;
      return Object.assign({}, props, { _stock_us: String(v.us), _stock_eu: String(v.eu) });
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var v = map[String(body.get('id'))];
      if (v) {
        body.set('properties[_stock_us]', String(v.us));
        body.set('properties[_stock_eu]', String(v.eu));
      }
      return body;
    }
    if (typeof body === 'string') {
      try {
        var data = JSON.parse(body);
        if (Array.isArray(data.items)) {
          data.items = data.items.map(function (i) {
            return Object.assign({}, i, { properties: tag(i.id, i.properties) });
          });
        } else if (data.id) {
          data.properties = tag(data.id, data.properties);
        }
        return JSON.stringify(data);
      } catch (e) { return body; }
    }
    return body;
  }

  function recalc() {
    if (running) { rerun = true; return running; }
    running = (async function () {
      do {
        rerun = false;
        var res = await nativeFetch(root + '?sections=eu-warehouse-check&_=' + Date.now(), {
          credentials: 'same-origin'
        });
        var sections = await res.json();
        var html = sections['eu-warehouse-check'] || '';
        var match = html.match(/\{[\s\S]*\}/);
        if (!match) throw new Error('eu-warehouse-check section not found');
        var data = JSON.parse(match[0]);
        setState(data);
        if (data.eu_warehouse_required !== data.current) {
          var attrs = {};
          attrs[ATTR] = data.eu_warehouse_required;
          await nativeFetch(root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        }
      } while (rerun);
    })()
      .catch(function (e) { console.error('[eu-warehouse]', e); })
      .finally(function () { running = null; });
    return running;
  }

  // fetch-based cart calls (Broadcast, many apps)
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!CART_MUTATION.test(url)) return nativeFetch(input, init);
    if (/\/cart\/add/.test(url) && init && init.body) {
      init = Object.assign({}, init, { body: injectProps(init.body) });
    }
    return nativeFetch(input, init).then(function (res) {
      if (res.ok) recalc();
      return res;
    });
  };

  // XHR-based cart calls (apps using axios / jQuery)
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__euUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var url = this.__euUrl || '';
    if (CART_MUTATION.test(url)) {
      if (/\/cart\/add/.test(url) && body) body = injectProps(body);
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) recalc();
      });
    }
    return xhrSend.call(this, body);
  };

  // Hold checkout until a pending update finishes (shadow-DOM aware)
  window.addEventListener('click', function (e) {
    if (!running) return;
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = path.some(function (el) {
      return el instanceof Element && CHECKOUT_SELECTORS.some(function (s) { return el.matches(s); });
    });
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
        running.then(function () {
      if (window.euWarehouse.isBlocked && window.euWarehouse.isBlocked()) return;
      window.location.href = root + 'checkout';
    });
  }, true);

  // Public hooks for CornerCart's custom JS
  window.euWarehouse = {
    recalc: recalc,
    checkoutSelectors: CHECKOUT_SELECTORS,
    required: null,
    data: null
  };

  var lastState = null;
  function setState(data) {
    window.euWarehouse.required = data.eu_warehouse_required === 'true';
    window.euWarehouse.data = data;
    var key = JSON.stringify(data);
    if (key === lastState) return;
    lastState = key;
    window.dispatchEvent(new CustomEvent('eu-warehouse:change', { detail: data }));
  }

  recalc();
  window.addEventListener('pageshow', function (e) { if (e.persisted) recalc(); });
})();